import type {ConfiguratorTrimResponseBody} from '@dms/api/new-vehicle';
import {getTrimOrderability, getTrimOrderabilityText} from '@dms/features/new-vehicle';
import i18n from '@dms/i18n';

const t = (key: string, fallback: string) => i18n.t(key, {defaultValue: fallback});

export const getOrderNowActionState = (
  trim: ConfiguratorTrimResponseBody | undefined,
  today: Date,
  formatDate: (date: Date) => string,
  canOrder = true
) => {
  if (!canOrder) {
    return {
      isDisabled: true,
      title: t(
        'entity.newVehicle.order.orderPermissionRequired',
        'You do not have permission to order configurations'
      ),
    };
  }
  const orderability = trim ? getTrimOrderability(trim, today) : undefined;
  const isDisabled = !orderability?.orderable;
  let title = t('entity.newVehicle.actions.orderNow', 'Order now…');
  if (isDisabled) {
    title = trim
      ? getTrimOrderabilityText(trim, today, formatDate)
      : t('entity.newVehicle.labels.unknownSelection', 'Unavailable selection');
  }
  return {isDisabled, title};
};
